import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, unref as _unref, createBlock as _createBlock } from "vue"

import { Form } from 'vee-validate';
import { ref, computed } from 'vue';
import { scrollToError } from '@/js/lib/helper/validate';
import { addToBasket } from '@/js/lib/api/cart';
import { useCartStore } from '@/js/lib/store/cart';
import { useCommonStore } from '@/js/lib/store/common';
import { useUserStore } from '@/js/lib/store/user';
import { info } from '@/js/lib/ui';
import { mountModal } from '@/js/lib/ui/helper/dynamic-modal';
import IButton from '@/js/components/molecules/IButton.vue';
import AlreadyInCartModal from '@/js/components/www.iichi.com/organisms/modals/AlreadyInCartModal.vue';
import CartModal from '@/js/components/www.iichi.com/organisms/modals/CartModal.vue';
import ItemOptions from './ItemOptions.vue';


export default /*@__PURE__*/_defineComponent({
  __name: 'cart-button',
  props: {
    itemId: {},
    shopId: {},
    stock: {},
    hasOption: {},
    isOnVacation: {},
    buttonLabel: {}
  },
  setup(__props: any) {

const props = __props;
const { isWebView } = useCommonStore();
const userStore = useUserStore();
const cartStore = useCartStore();
const cartButtonEl = document.querySelector('.cart-button') as HTMLDivElement;
const cartButtonFixedEl = document.querySelector('.cart-button-fixed') as HTMLDivElement;
const itemOptionVariantSlugs = ref<string[]>([]);
const available = computed(() => {
  if (props.shopId === userStore.memberId || props.isOnVacation || userStore.isBlackListed) {
    return false;
  }
  return props.stock > 0;
});
const onClickSelectOptionButton = () => {
  cartButtonEl.scrollIntoView({
    behavior: 'smooth',
    block: 'center',
  });
};
const onError = () => {
  cartButtonFixedEl.style.display = 'none';
  scrollToError();
};
const onSubmit = async () => {
  if (available.value) {
    // 以前のeコマースオブジェクトをクリアする
    // eslint-disable-next-line unicorn/no-null
    window.dataLayer?.push({ ecommerce: null });
    window.dataLayer?.push({
      event: 'add_to_cart',
      ecommerce: {
        items: [
          {
            item_id: props.itemId,
            quantity: 1,
          },
        ],
      },
    });
    try {
      await addToBasket({ itemId: props.itemId, itemOptionVariantSlugs: itemOptionVariantSlugs.value });
      if (isWebView) {
        info('カートに追加されました', { fadeOut: true });
        return;
      }
      await cartStore.loadBaskets();
      mountModal({
        Component: CartModal,
      });
    } catch (error) {
      if (error?.response?.data?.errors.includes('already_in_cart')) {
        mountModal({
          Component: AlreadyInCartModal,
          props: {
            itemId: props.itemId,
            itemOptionVariantSlugs: itemOptionVariantSlugs.value,
          },
        });
        return;
      }
      if (error?.response?.data?.errors.includes('stock_missing')) {
        info('注文個数が在庫数を超えています');
        return;
      }
      info('カートに追加できませんでした');
    }
  }
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(Form), {
    class: _normalizeClass(_ctx.$style.form),
    onInvalidSubmit: onError,
    onSubmit: onSubmit
  }, {
    default: _withCtx(() => [
      _createVNode(ItemOptions, {
        modelValue: itemOptionVariantSlugs.value,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((itemOptionVariantSlugs).value = $event)),
        "item-id": _ctx.itemId
      }, null, 8, ["modelValue", "item-id"]),
      _cache[2] || (_cache[2] = _createTextVNode()),
      _createElementVNode("div", {
        class: _normalizeClass(_ctx.$style.cartButton)
      }, [
        _createVNode(IButton, {
          type: "primary",
          "native-type": "submit",
          disabled: !available.value
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.buttonLabel || 'カートに入れる'), 1)
          ]),
          _: 1
        }, 8, ["disabled"]),
        _cache[1] || (_cache[1] = _createTextVNode()),
        (_ctx.hasOption)
          ? (_openBlock(), _createElementBlock("button", {
              key: 0,
              type: "button",
              class: _normalizeClass(_ctx.$style.cartButtonOption),
              onClick: onClickSelectOptionButton
            }, "購入オプションを選ぶ", 2))
          : _createCommentVNode("", true)
      ], 2)
    ]),
    _: 1,
    __: [2]
  }, 8, ["class"]))
}
}

})